import { useSelector } from "@tanstack/react-form";
import { useEffect } from "react";
import type { FieldValue, SimpleFieldValue } from "../../../types";
import { useFormContext } from "../form/form-context";

type Props<T> = {
	when: string;
	is: T;
	children: React.ReactNode;
	fieldName?: string;
};

export const Condition = <T extends SimpleFieldValue = string>({
	when,
	is,
	children,
	fieldName,
}: Props<T>) => {
	const form = useFormContext();
	const whenValue = useSelector(
		form.store,
		(state) => (state.values as Record<string, FieldValue>)[when],
	);
	const isSubQuestionActive = whenValue === is;

	useEffect(() => {
		if (!isSubQuestionActive && fieldName) {
			form.setFieldValue(fieldName as never, undefined as never);
		}
	}, [fieldName, form, isSubQuestionActive]);

	if (isSubQuestionActive) return children;

	return null;
};
